import { render, staticRenderFns } from "./KioskGlobal.vue?vue&type=template&id=7d55df46"
import script from "./KioskGlobal.vue?vue&type=script&lang=js"
export * from "./KioskGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports